/**
 * 本地模拟数据模块（前端原型阶段使用）
 * 后续接入后端时：将 queryReminder 替换为 MaintananceSingleReminder，
 * 重置记录的增删改查替换为对应真实接口（act 见各函数注释）。
 */

// ---------------- 维保零部件清单（重置时从下方选择） ----------------
export const resetPartOptions = [
  { id: 1, name: '发动机油' },
  { id: 2, name: '机油滤清器' },
  { id: 3, name: '柴油滤清器' },
  { id: 4, name: '空气滤芯' },
  { id: 5, name: '空调滤芯（吹灰尘）' },
  { id: 6, name: '制动液' },
  { id: 7, name: '离合器油' },
  { id: 8, name: '转向油' },
  { id: 9, name: '变速箱油' },
  { id: 10, name: '后桥齿轮油' },
  { id: 11, name: '轮胎换位' },
  { id: 12, name: '空气干燥器' },
  { id: 13, name: '防冻液' }
]

// ---------------- 维保提醒列表（模拟 MaintananceSingleReminder 返回） ----------------
// PartIds 为维保零部件 ID；只有当零部件 ID 中包含 13 时才显示"提醒时间"
export const mockReminderList = [
  {
    RecordID: 1, VehicleID: 1001, CarNo: '粤B12345', VehicleModel: 'BYD 宋PLUS',
    EMileage: 120000, PartIds: [1, 2, 5], Parts: '发动机油,机油滤清器,空调滤芯（吹灰尘）',
    Marker: 121000, UpdateTime: '2026-08-30 09:00:00', IsRead: 0
  },
  {
    RecordID: 2, VehicleID: 1002, CarNo: '粤B67890', VehicleModel: '比亚迪 秦EV',
    EMileage: 86500, PartIds: [6, 9], Parts: '制动液,变速箱油',
    Marker: 87000, UpdateTime: '2026-08-28 16:20:00', IsRead: 1
  },
  {
    RecordID: 3, VehicleID: 1003, CarNo: '粤B11223', VehicleModel: '上汽荣威 ER6',
    EMileage: 54000, PartIds: [1], Parts: '发动机油',
    Marker: 56000, UpdateTime: '2026-08-27 11:40:00', IsRead: 0
  },
  {
    RecordID: 4, VehicleID: 1004, CarNo: '粤B44556', VehicleModel: '吉利帝豪EV',
    EMileage: 132000, PartIds: [2, 11, 13], Parts: '机油滤清器,轮胎换位,防冻液',
    Marker: 134000, UpdateTime: '2026-08-26 08:15:00', IsRead: 0
  },
  {
    RecordID: 5, VehicleID: 1005, CarNo: '粤B77889', VehicleModel: '广汽埃安 S',
    EMileage: 96000, PartIds: [6, 13], Parts: '制动液,防冻液',
    Marker: 97000, UpdateTime: '2026-08-24 15:30:00', IsRead: 1
  },
  {
    RecordID: 6, VehicleID: 1006, CarNo: '粤B33344', VehicleModel: '特斯拉 Model 3',
    EMileage: 41000, PartIds: [12], Parts: '空气干燥器',
    Marker: 42000, UpdateTime: '2026-08-23 10:05:00', IsRead: 0
  },
  {
    RecordID: 7, VehicleID: 1007, CarNo: '粤B55667', VehicleModel: '江淮 iEV6E',
    EMileage: 78000, PartIds: [1, 3], Parts: '发动机油,柴油滤清器',
    Marker: 79000, UpdateTime: '2026-08-22 13:50:00', IsRead: 1
  },
  {
    RecordID: 8, VehicleID: 1008, CarNo: '粤B88990', VehicleModel: '北汽 EU5',
    EMileage: 112000, PartIds: [13], Parts: '防冻液',
    Marker: 113000, UpdateTime: '2026-08-20 17:00:00', IsRead: 0
  }
]

// 分页查询维保提醒：act 建议 v1/maintananceSingleReminder（IsRead: -1 表示全部）
export function queryReminder({ VehicleModel = '', IsRead = -1, PageNo = 1, PageSize = 10 } = {}) {
  let list = mockReminderList.slice()
  if (VehicleModel) {
    list = list.filter(r => r.VehicleModel.indexOf(VehicleModel) !== -1)
  }
  if (IsRead !== -1 && IsRead !== '-1') {
    list = list.filter(r => r.IsRead === Number(IsRead))
  }
  const total = list.length
  const start = (PageNo - 1) * PageSize
  return Promise.resolve({ code: 200, data: list.slice(start, start + PageSize), count: total })
}

// 修改提醒记录的阅读状态：act 建议 v1/maintananceChangeRead（isRead: 1已读 / 0未读）
export function updateReminderRead(recordID, isRead) {
  const idx = mockReminderList.findIndex(r => r.RecordID === recordID)
  if (idx > -1) {
    mockReminderList[idx].IsRead = Number(isRead)
  }
  return Promise.resolve({ code: 200 })
}

// ---------------- 维保重置记录（内存存储，两个页面间共享） ----------------
// ResetParts 为已选零部件名称数组
let _resetRecords = [
  {
    RecordID: 1, CarNo: '粤B12345', ResetTime: '2026-08-20 10:30:00', ResetMileage: 120000,
    ResetParts: ['发动机油', '机油滤清器', '空调滤芯（吹灰尘）'], Location: '深圳市福田区XX汽修厂', Remark: '例行保养'
  },
  {
    RecordID: 2, CarNo: '粤B67890', ResetTime: '2026-08-25 14:00:00', ResetMileage: 86500,
    ResetParts: ['制动液', '变速箱油'], Location: '东莞市南城XX养护中心', Remark: ''
  }
]
let _nextId = 3

// 分页查询重置记录：act 建议 v1/maintananceResetRecord
export function queryResetRecord({ PageNo = 1, PageSize = 10 } = {}) {
  const total = _resetRecords.length
  const start = (PageNo - 1) * PageSize
  const list = _resetRecords.slice(start, start + PageSize)
  return Promise.resolve({ code: 200, data: list, count: total })
}

// 新增重置记录（提醒页重置操作同样调用此函数自动生成一条记录）：act 建议 v1/maintananceResetRecordAdd
export function addResetRecord(record) {
  const newRecord = {
    RecordID: _nextId++,
    CarNo: record.CarNo,
    ResetTime: record.ResetTime,
    ResetMileage: record.ResetMileage,
    ResetParts: toPartsArray(record.ResetParts),
    Location: record.Location || '',
    Remark: record.Remark || ''
  }
  _resetRecords.unshift(newRecord)
  return Promise.resolve({ code: 200, data: newRecord })
}

// 修改重置记录：act 建议 v1/maintananceResetRecordEdit
export function updateResetRecord(record) {
  if (record.ResetParts) {
    record = { ...record, ResetParts: toPartsArray(record.ResetParts) }
  }
  const idx = _resetRecords.findIndex(r => r.RecordID === record.RecordID)
  if (idx > -1) {
    _resetRecords[idx] = { ..._resetRecords[idx], ...record }
  }
  return Promise.resolve({ code: 200 })
}

// 删除重置记录：act 建议 v1/maintananceResetRecordDelete
export function deleteResetRecord(recordID) {
  _resetRecords = _resetRecords.filter(r => r.RecordID !== recordID)
  return Promise.resolve({ code: 200 })
}

// 将零部件统一格式化为名称数组（兼容字符串，逗号/分号/顿号分隔）
function toPartsArray(parts) {
  if (Array.isArray(parts)) return parts.slice()
  if (!parts) return []
  return String(parts).split(/[,，;；、]+/).filter(Boolean)
}

// ---------------- 车牌号列表（重置时下拉选择） ----------------
// 查询车牌号列表：act 建议 v1/queryVehicleNoList
// 每次调用时即时汇总，避免模块加载期的初始化顺序问题
export function queryCarList() {
  const carSet = new Set()
  mockReminderList.forEach(r => r.CarNo && carSet.add(r.CarNo))
  _resetRecords.forEach(r => r.CarNo && carSet.add(r.CarNo))
  ;['粤B22222', '粤B66666'].forEach(c => carSet.add(c))
  return Promise.resolve({ code: 200, data: Array.from(carSet) })
}